import { Nullable } from '@ps/utils';
import { FusionStats } from '@ps/survey-utils';

export interface SurveyManagementState {
  readonly buyerProjectManagerUpdating: boolean;
  readonly operatorProjectManagerUpdating: boolean;
  readonly error: Nullable<string>;
  // Links & Other Details drawer — operator tools (fusion block actions).
  readonly creatingPriceBlock: boolean;
  readonly priceBlockError: Nullable<string>;
  readonly resettingFusionBlockStats: boolean;
  readonly fusionBlockResetError: Nullable<string>;
  readonly fusionStats: Nullable<FusionStats>;
  readonly fusionStatsLoading: boolean;
  readonly fusionStatsError: Nullable<string>;
}

export const INITIAL_SURVEY_MANAGEMENT_STATE: SurveyManagementState = {
  buyerProjectManagerUpdating: false,
  operatorProjectManagerUpdating: false,
  error: null,
  creatingPriceBlock: false,
  priceBlockError: null,
  resettingFusionBlockStats: false,
  fusionBlockResetError: null,
  fusionStats: null,
  fusionStatsLoading: false,
  fusionStatsError: null,
};
